<div class="list-icons">
  <p>
    <span class="icon-i-lock"></span>
    {{
      (currentAccountType === '3a' ? 'steps.id5.account_to_fund.description_1-3a' : 'steps.id5.account_to_fund.description_1') | translate
    }}
  </p>
  <p>
    <span class="icon-i-time"></span>
    {{
      (currentAccountType === '3a' ? 'steps.id5.account_to_fund.description_2-3a' : 'steps.id5.account_to_fund.description_2') | translate
    }}
  </p>
  <p>
    <span class="icon-i-email"></span>
    {{
      (currentAccountType === '3a' ? 'steps.id5.account_to_fund.description_3-3a' : 'steps.id5.account_to_fund.description_3') | translate
    }}
  </p>
  <p *ngIf="currentAccountType === '3a'">
    <span class="icon-i-document"></span>{{ 'steps.id5.account_to_fund.description_4-3a' | translate }}
  </p>
</div>
